export default __webpack_public_path__ + "static/media/visibility_black_24dp (2).cda8ec09.svg";